import { persianLanguage } from "../../../constants/persianTerms";
import { useAuth } from "../../auth/auth-provider/auth-provider";
import { useServerTimeStore } from "../../stores/serverTimeStore";
import { useRealtimeHealth } from "../../realtime/health/useRealtimeHealth";
import { getServerStatusMessage } from "../../realtime/health/utils/getServerStatusMessage";
import "./UserCommunicationWithServer.css";

export default function UserCommunicationWithServer() {
    const auth = useAuth();
    const health = useRealtimeHealth();
    const time = useServerTimeStore(state => state.serverDateTime);

    if (!auth?.token || !auth?.user || auth.user.isAdmin) return null;

    return (
        <div className="user-server-status" role="group"
             aria-label={persianLanguage.phrase.server.CONNECTION_WITH_SERVER}>
            <span className="user-server-status__label">
                {persianLanguage.phrase.server.CONNECTION_WITH_SERVER}:
            </span>
            <span className="user-server-status__value">
                {getServerStatusMessage(health, time)}
            </span>
        </div>
    );
}
